import { SubmissionError } from "redux-form";

import { API_BASE_URL } from "../config";
import { normalizeResponseErrors } from "./utils";

export const postRating = rating => dispatch => {
  return fetch(`${API_BASE_URL}/ratings`, {
    method: "POST",
    headers: {
      "content-type": "application/json"
    },
    body: JSON.stringify(rating)
  })
    .then(res => normalizeResponseErrors(res))
    .then(res => res.json())
    .catch(err => {
      const { reason, message, location } = err;
      if (reason === "ValidationError") {
        // Convert ValidationErrors into SubmissionErrors for Redux Form
        return Promise.reject(
          new SubmissionError({
            [location]: message
          })
        );
      }
    });
};



// WEBPACK FOOTER //
// ./src/actions/rating.js